const CUSTOM_ERROR_CODES = {
  '1001':
    'Seems like this phone number is already registered with another account. Please try with other number.',
  '1002': 'No space allowed in Email ID.',
  '1003': 'The password should have at least 6 characters.',
  '1004': 'Please enter a valid Email ID.',
};

export const ERROR_MESSAGES = {
  generic:
    'Something went wrong. Please reach us at 080-67458744 or invest@cleartax.in',
};

export default CUSTOM_ERROR_CODES;



// WEBPACK FOOTER //
// ./constants/errorCodes.ts